import * as React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';
import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const drawerOverlayVariants = cva(
    'rocco-drawer-overlay fixed z-modalBackdrop',
    {
        variants: {
            variant: {
                default: 'inset-0 bg-black/80',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
);

export const DrawerOverlay = React.forwardRef<
    React.ElementRef<typeof DrawerPrimitive.Overlay>,
    React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Overlay> &
        VariantProps<typeof drawerOverlayVariants>
>(({ className, variant, ...props }, ref) => (
    <DrawerPrimitive.Overlay
        ref={ref}
        className={cn(drawerOverlayVariants({ variant, className }))}
        {...props}
    />
));

DrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName;
